import { ErrorMessage, Field, Form, Formik } from "formik";
import React from "react";
import HeaderDescription from "../../../../components/commons/HeaderDescription";

const CompanyInformation = ({ onboardingData }) => {
  return (
    <div>
      <div className="width-ful">
        <Formik
          initialValues={{
            companyName: onboardingData
              ? onboardingData?.user?.companyName || ""
              : "",
            companyAddress: onboardingData
              ? onboardingData?.user?.companyAddress || ""
              : "",
            companyPostCode: onboardingData
              ? onboardingData?.user?.companyPostCode || ""
              : "",
            companyCity: onboardingData
              ? onboardingData?.user?.companyCity || ""
              : "",
            companyRegistrationNumber: onboardingData
              ? onboardingData?.user?.companyRegistrationNumber || ""
              : "",
            companyVATNumber: onboardingData
              ? onboardingData?.user?.companyVATNumber || ""
              : "",
            IBAN: onboardingData ? onboardingData?.user?.IBAN || "" : "",
            bankAccountHolderName: onboardingData
              ? onboardingData?.user?.bankAccountHolderName || ""
              : "",
          }}
        >
          {({ values }) => (
            <Form>
              <div className="bg-white main-section-spacing-md border-radius-8">
                <HeaderDescription
                  heading="Company Information"
                  description="Fill in your company details below."
                />

                <div className="mt-20">
                  {/* Row 1 */}
                  <div className="flex align-item-center gap-32">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Company Name</label>
                        <Field
                          type="text"
                          name="companyName"
                          placeholder="Company Name"
                          className="type-input-focus"
                          value={values.companyName}
                        />
                        <ErrorMessage
                          name="companyName"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Company Address</label>
                        <Field
                          type="text"
                          name="companyAddress"
                          placeholder="Company Address"
                          className="type-input-focus"
                          value={values.companyAddress}
                        />
                        <ErrorMessage
                          name="companyAddress"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Row 2 */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Post Code</label>
                        <Field
                          type="text"
                          name="companyPostCode"
                          placeholder="Post Code"
                          className="type-input-focus"
                          value={values.companyPostCode}
                        />
                        <ErrorMessage
                          name="companyPostCode"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>City</label>
                        <Field
                          type="text"
                          name="companyCity"
                          placeholder="City"
                          className="type-input-focus"
                          value={values.companyCity}
                        />
                        <ErrorMessage
                          name="companyCity"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Row 3 */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Registration Number</label>
                        <Field
                          type="text"
                          name="companyRegistrationNumber"
                          placeholder="Company Registration Number"
                          className="type-input-focus"
                          value={values.companyRegistrationNumber}
                        />
                        <ErrorMessage
                          name="companyRegistrationNumber"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>VAT Number</label>
                        <Field
                          type="text"
                          name="companyVATNumber"
                          placeholder="Company VAT Number"
                          className="type-input-focus"
                          value={values.companyVATNumber}
                        />
                        <ErrorMessage
                          name="companyVATNumber"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Row 4 */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>IBAN</label>
                        <Field
                          type="text"
                          name="IBAN"
                          placeholder="IBAN"
                          className="type-input-focus"
                          value={values.IBAN}
                        />
                        <ErrorMessage
                          name="IBAN"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Bank Account Holder Name</label>
                        <Field
                          type="text"
                          name="bankAccountHolderName"
                          placeholder="Bank Account Holder Name"
                          className="type-input-focus"
                          value={values.bankAccountHolderName}
                        />
                        <ErrorMessage
                          name="bankAccountHolderName"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CompanyInformation;
